import type { FC } from 'react';
import React from 'react';

import Spinner from '@atlaskit/spinner/spinner';

import { SpinnerContainer } from './SpaceCustomContentListView-styles';

export const CustomContentLoading: FC<{}> = () => (
	<SpinnerContainer data-testid="custom-content-loading">
		<Spinner size="large" />
	</SpinnerContainer>
);
